import {GetterTree} from 'vuex';
import {RootState} from '@/store';
import {ProfileState} from '@/store/modules/Profile/state';
import {AuthorProfile, BlackListUser, MyProfileAPI} from '#/User';

export const getters: GetterTree<ProfileState, RootState> = {
    authorProfile: (state: ProfileState): AuthorProfile => state.authorProfile,
    isAdmin: (state: ProfileState): boolean => state.profile.isAdmin,
    hasSyncAction: (state: ProfileState): boolean => {
        return state.profile.organization === 'UDS' && process.env.VUE_APP_ACTIVE_SYNC_ACTION === 'true';
    },
    profile: (state: ProfileState): MyProfileAPI => state.profile,
    blacklist: (state: ProfileState): BlackListUser[] => state.profile.blacklist,
};
